import React from 'react';
import Fact from '../../components/Fact';
import Status from '../../components/Status';
import TeaserContent from '../../components/TeaserContent';
import TeaserTools from '../../components/TeaserTools';
import TeaserStorys from '../../components/TeaserStorys';
import TeaserNewsCard from '../../components/TeaserCard/TeaserNewsCard';
import Publication from '../../components/Publication';
import TeaserAusAltMachNeu from '../../components/TeaserAusAltMachNeu/TeaserAusAltMachNeu';
import Event from '../../components/Event';

// eslint-disable-next-line react/display-name
export default (block: {
  component: string;
  _uid: string;
  item: any;
  lang?: string;
}) => {
  interface IMapping {
    [propertyName: string]: React.FC<any>;
  }

  const Components: IMapping = {
    TeaserContent,
    TeaserTools,
    Fact,
    Status,
    TeaserStorys,
    TeaserNewsCard,
    Publication,
    Publications: Publication,
    TeaserAusAltMachNeu,
    Event,
  };

  if (block.lang) {
    block.item.lang = block.lang;
  }

  if (
    typeof block.component === 'string' &&
    typeof block.component !== null &&
    typeof block.component !== undefined
  ) {
    if (typeof Components[block.component] !== 'undefined') {
      return React.createElement(Components[block.component], {
        key: block._uid,
        data: block.item,
      });
    }
  }
  return React.createElement(
    () => (
      <div>
        The component {block.component} has not been created yet.{' '}
        {JSON.stringify(Components)}
      </div>
    ),
    { key: block._uid },
  );
};
